<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal title="Application Details" ref="applicationDetails" size="xl" hide-footer>
        <CopyrightAssignmentTransferDetails :tracking-number="trackingNumber"/>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">CopyrightAssignmentTransfer Applications</span>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="flex mx-3 mt-3">
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="pre-waiting">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto" >{{getCopyrightAssignmentTransferStatistics.draft.toLocaleString()}}</span>
        </div>
        <div class="pre-waiting">
          <span class="text-sm mx-auto">Drafts</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="waiting">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto" >{{getCopyrightAssignmentTransferStatistics.pending.toLocaleString()}}</span>
        </div>
        <div class="waiting">
          <span class="text-sm mx-auto">In Queue</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="normal">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAssignmentTransferStatistics.assigned.toLocaleString()}}</span>
        </div>
        <div class="normal">
          <span class="text-sm mx-auto">Assigned</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="off-normal">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAssignmentTransferStatistics.escalated.toLocaleString()}}</span>
        </div>
        <div class="off-normal">
          <span class="text-sm mx-auto">Escalated</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAssignmentTransferStatistics.queried.toLocaleString()}}</span>
        </div>
        <div class="warning">
          <span class="text-sm mx-auto">Queried</span>
        </div>
      </div>

      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="positive">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAssignmentTransferStatistics.approved.toLocaleString()}}</span>
        </div>
        <div class="positive">
          <span class="text-sm mx-auto">Approved</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="all">
          <span v-if="getCopyrightAssignmentTransferStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAssignmentTransferStatistics.total.toLocaleString()}}</span>
        </div>
        <div class="all">
          <span class="text-sm mx-auto">Total</span>
        </div>
      </div>
    </b-row>
    <b-row class="flex">
      <b-col cols="12">
        <b-row class="pt-3">
          <b-col>
            <AllCopyrightAssignmentTransferSubmissions @openDetails="openDetails" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AllCopyrightAssignmentTransferSubmissions from "@/views/home/services/copyright-assignment-transfer/submissions/AllCopyrightAssignmentTransferSubmissions.vue";
import CopyrightAssignmentTransferDetails from "@/views/home/services/copyright-assignment-transfer/submissions/CopyrightAssignmentTransferDetails.vue";

export default {
  name: "CopyrightAssignmentTransferApplications",
  components: {
    CopyrightAssignmentTransferDetails,
    AllCopyrightAssignmentTransferSubmissions,
  },
  data(){
    return{
      currentRoute: "pending",
      trackingNumber:null,
    }
  },
  mounted(){
    this.fetchCopyrightAssignmentTransferStatistics()
  },
  methods:{
    ...mapActions(["fetchCopyrightAssignmentTransferStatistics"]),
    select(route){
      this.currentRoute = route
    },
    openDetails(trackingNumber){
      this.trackingNumber = trackingNumber
      this.$refs.applicationDetails.show()
    }
  },
  computed:{
    ...mapGetters(["getCopyrightAssignmentTransferStatistics"])
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.pre-waiting{
  @apply flex text-gray_title;
}

.off-normal{
  @apply flex text-blue-light;
}

.waiting{
  @apply flex text-gray;
}

.normal{
  @apply flex text-blue;
}

.positive{
  @apply flex text-green;
}

.warning{
  @apply flex text-orange;
}

.all{
  @apply flex text-flopurple;
}

.stat-count{
  display: inline;
  width: 12%;
  @apply my-1;
}
</style>
